import React from 'react'

export function Btn({ children, onClick, disabled, variant = 'ghost' }) {
  const s = {
    primary: { background: '#ff3b30', color: '#fff', border: 'none' },
    sync:    { background: '#007aff', color: '#fff', border: 'none' },
    ghost:   { background: 'var(--card-bg)', color: 'var(--text)', border: '1px solid var(--border)' },
    muted:   { background: 'transparent', color: 'var(--text-faint)', border: '1px solid #ebebeb' },
  }
  return (
    <button onClick={onClick} disabled={disabled} style={{
      ...s[variant], borderRadius: 8, padding: '5px 12px', fontSize: 12, fontWeight: 500,
      cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.4 : 1,
      transition: 'opacity 0.15s', whiteSpace: 'nowrap', fontFamily: 'inherit',
    }}>{children}</button>
  )
}
